export const confirmOnlineWarning = () => ({
    type: 'CONFIRM_ONLINE_WARNING'
});


// WEBPACK FOOTER //
// ./src/actions/onlineWarning.js